import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import classNames from 'classnames';

import {
  fetchTradeSupportingDocuments,
  removeTradeSupportingDocuments,
} from '../actions';

import {resolvePurchaseOrderNotifications} from '../../trade_documents/purchaseOrdersActions';
import {resolveInvoiceNotifications} from '../../trade_documents/invoicesActions';
import {
  fetchUserTradeDocument,
  updateTradeDocument,
} from '../../trade_documents/actions';

import Layout from '../../shared/components/layouts/MainLayout';
import FullPageLayout from '../../shared/components/layouts/FullPageLayout';

import Form from './Form';
import SelectFiles from './SelectFiles';

import {segmentEventTracker} from '../../../utils/SegmentEventTracker';
import {
  PageViewName,
  TrackEventName,
} from '../../shared/constants/SegmentEvents';

class TradeSupportingDocuments extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: {},
      success: false,
      loading: false,
      processingAttachments: false,
      trade_supporting_documents: this.props.trade_supporting_documents || [],
      trade_document: this.props.trade_document,
    };
  }

  componentWillMount() {
    this.setState({loading: true});
    this.props.dispatch(
      fetchUserTradeDocument(
        this.props.user_id,
        this.tradeDocumentType,
        this.props.match.params['id'],
      ),
    );
    this.props.dispatch(
      fetchTradeSupportingDocuments(
        this.props.user_id,
        this.tradeDocumentType,
        this.props.match.params['id'],
        () => this.setState({loading: false}),
      ),
    );
  }

  componentDidMount() {
    segmentEventTracker.trackPageView(
      PageViewName.TRADE_DOC_ADD_SUPPORTING_DOC_VIEWED,
    );
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.trade_supporting_documents || []).length === 0 &&
      (this.props.trade_supporting_documents || []).length > 0
    ) {
      this.setState({
        trade_supporting_documents: this.props.trade_supporting_documents,
      });
    }
  }

  buttonClassNames() {
    return classNames('ds-btn', '--large', '--block', '_outsideCard', {
      _loading: this.state.loading,
    });
  }

  formClassNames() {
    const isLoading =
      this.state.loading && this.props.trade_supporting_documents.length === 0;
    return classNames('cardSection', {loading: isLoading});
  }

  get isPurchaseOrder() {
    return this.tradeDocumentType === 'purchase_orders';
  }

  get tradeDocumentType() {
    return this.props.match.params['0'];
  }

  get titleizedTradeDoc() {
    return this.isPurchaseOrder ? 'Purchase Order' : 'Invoice';
  }

  get singularizedTradeDocType() {
    return this.isPurchaseOrder ? 'purchase_order' : 'invoice';
  }

  bulkData = () => {
    let formData = new FormData();
    this.state.trade_supporting_documents.forEach(tsd => {
      formData.append(
        `${this.singularizedTradeDocType}[trade_supporting_documents_attributes[][id]]`,
        tsd.id,
      );
      formData.append(
        `${this.singularizedTradeDocType}[trade_supporting_documents_attributes[][description]]`,
        tsd.description || '',
      );
    });

    return formData;
  };

  onBack = () => {
    segmentEventTracker.trackEvent(TrackEventName.BACK_CLICKED);
    this.props.dispatch(
      push(`/${this.tradeDocumentType}/${this.props.match.params.id}`),
    );
  };

  onSubmit = () => {
    segmentEventTracker.trackEvent(TrackEventName.SUBMIT_FORM_CLICKED);
    this.setState({loading: true});
    return updateTradeDocument(
      this.props.user_id,
      this.tradeDocumentType,
      this.props.match.params['id'],
      this.bulkData(),
    ).then(() => {
      this.resolveNotifications();
    });
  };

  onClickModalCancel = () => {
    segmentEventTracker.trackEvent(
      TrackEventName.SUPPORTING_DOCUMENT_MODAL_NO_CLICKED,
    );
  };

  onClickModalClose = () => {
    segmentEventTracker.trackEvent(
      TrackEventName.SUPPORTING_DOCUMENT_MODAL_CLOSE_CLICKED,
    );
  };

  onClickModalConfirm = () => {
    segmentEventTracker.trackEvent(
      TrackEventName.SUPPORTING_DOCUMENT_MODAL_YES_CLICKED,
    );
  };

  onClickDescription = () => {
    segmentEventTracker.trackEvent(TrackEventName.DOCUMENT_DESCRIPTION_CLICKED);
  };

  onClickFileInput = () => {
    const event =
      this.state.trade_supporting_documents.length >= 1
        ? TrackEventName.SUPPORTING_DOCUMENT_ADD_ANOTHER_CLICKED
        : TrackEventName.SUPPORTING_DOCUMENT_ADD_CLICKED;
    segmentEventTracker.trackEvent(event);
  };

  onDeleteDocument = () => {
    segmentEventTracker.trackEvent(
      TrackEventName.SUPPORTING_DOCUMENT_REMOVE_CLICKED,
    );
  };

  shouldResolveNotification = () => {
    return (
      this.props.trade_document.notification &&
      this.props.trade_document.notification.fca_action.includes(
        'supporting_document',
      )
    );
  };

  resolveNotifications = () => {
    if (this.shouldResolveNotification()) {
      const body = {
        fca_action: this.props.trade_document.notification.fca_action,
      };
      const resolveTradeDocument = this.isPurchaseOrder
        ? resolvePurchaseOrderNotifications
        : resolveInvoiceNotifications;

      this.props.dispatch(
        resolveTradeDocument(
          body,
          this.props.match.params['id'],
          this.props.user_id,
          () => {
            this.setState({success: true, loading: false});
          },
        ),
      );
    } else {
      this.setState({success: true, loading: false});
    }
  };

  updateTradeSupportingDocumentItem = (data, item) => {
    let trade_supporting_documents = [...this.state.trade_supporting_documents];
    trade_supporting_documents[item] = data;

    this.setState({trade_supporting_documents});
  };

  deleteTradeSupportingDocumentItem = id => {
    const trade_supporting_documents = this.state.trade_supporting_documents.filter(
      item => {
        return item.id !== id;
      },
    );

    this.setState({trade_supporting_documents});
  };

  toggleProcessingAttachments = () => {
    this.setState({
      processingAttachments: !this.state.processingAttachments,
    });
  };

  renderFormList = () => {
    return (
      <Fragment>
        {this.props.trade_supporting_documents.length === 0 && (
          <div className="ds-card">
            <section className="cardSection">
              <p className="copy -secondary _alignCenter">
                {' '}
                No Supporting Documents{' '}
              </p>
            </section>
          </div>
        )}
        {this.props.trade_supporting_documents.map((tsd, index) => {
          return (
            <div className="ds-card">
              <section className="sectionList _withForm">
                <Form
                  data={tsd}
                  ref={index}
                  key={tsd.id}
                  listID={index}
                  tradeDocumentType={this.tradeDocumentType}
                  tradeDocumentID={this.props.match.params['id']}
                  updateItem={this.updateTradeSupportingDocumentItem}
                  deleteItem={this.deleteTradeSupportingDocumentItem}
                  onDeleteDocument={this.onDeleteDocument}
                  onClickDescription={this.onClickDescription}
                  onClickModalCancel={this.onClickModalCancel}
                  onClickModalClose={this.onClickModalClose}
                  onClickModalConfirm={this.onClickModalConfirm}
                />
              </section>
            </div>
          );
        })}
      </Fragment>
    );
  };

  renderProcessingFiles = () => {
    if (this.state.processingAttachments) {
      return (
        <section className="cardSection">
          <p className="copy -secondary _alignCenter">
            Uploading files
            <div className="loading" style={{height: 45, width: 45}} />
          </p>
        </section>
      );
    }
  };

  renderUploadButton = () => {
    return (
      <SelectFiles
        tradeDocumentType={this.tradeDocumentType}
        tradeDocumentID={this.props.match.params.id}
        listID={this.state.trade_supporting_documents.length}
        toggleProcessingAttachments={this.toggleProcessingAttachments}
        onClickFileInput={this.onClickFileInput}
      />
    );
  };

  renderSubmitButton = () => {
    if (this.props.trade_supporting_documents.length === 0) return;
    return (
      <button
        className={this.buttonClassNames()}
        onClick={this.onSubmit}
        disabled={this.state.loading}
        data-testid="submit-documents-button">
        Submit Documents
      </button>
    );
  };

  renderForm = () => {
    return (
      <Layout
        backButtonAction={this.onBack}
        backButtonLabel="Add Supporting Documents">
        <div className="ds-cardList">
          <div className="ds-card">
            <section className="cardTitle">Supporting Documents</section>
            <section className="cardSection">
              <p className="byline">
                These documents help provide additional proof of your
                transaction with your client.{' '}
              </p>
            </section>
            {this.renderUploadButton()}
          </div>
          {this.renderFormList()}
          {this.renderProcessingFiles()}
          {this.renderSubmitButton()}
        </div>
      </Layout>
    );
  };

  renderSuccess = () => {
    return (
      <FullPageLayout>
        <div className="ds-card ds-fullPagePrompt">
          <div className="cardSection _eventPrompt">
            <i className="materialIcon --large -success">
              check_circle_outline
            </i>
            <h1 className="subhead">Documents succesfully uploaded!</h1>
          </div>
          <button
            className="ds-btn --full"
            onClick={() => {
              this.props.dispatch(removeTradeSupportingDocuments());
              this.props.dispatch(
                push(
                  `/${this.tradeDocumentType}/${this.props.trade_document.id}`,
                ),
              );
            }}>
            Back to {`${this.titleizedTradeDoc}`}
          </button>
        </div>
      </FullPageLayout>
    );
  };

  renderView = () => {
    return this.state.success ? this.renderSuccess() : this.renderForm();
  };

  render() {
    return this.renderView();
  }
}

const mapStateToProps = state => {
  return {
    user_id: state.user.id,
    trade_document: state.tradeDocuments.current,
    trade_supporting_documents: state.trade_supporting_documents,
  };
};

export default connect(mapStateToProps)(TradeSupportingDocuments);



// WEBPACK FOOTER //
// ./src/features/supporting_documents/containers/SupportingDocuments.js